import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class InviteService {
  
  public invite: { guid: string };
}

